export default __webpack_public_path__ + "static/media/Collection.9a779485.svg";